export default {
  path: '/warehouse-work-tracker',
  component: () => import('@/views/warehouseWorkTracker/index.vue'),
  children: [
    {
      path: 'dashboard',
      name: 'WarehouseWorkDashboard',
      component: () => import('@/views/warehouseWorkTracker/pages/WarehouseWorkDashboard.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'accounting_manager',
          'inventory_and_costing',
          'warehouse_manager',
          'support'
        ]
      }
    },
    {
      path: 'employee-status',
      name: 'WarehouseEmployeeStatus',
      component: () => import('@/views/warehouseWorkTracker/pages/EmployeeStatus.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'accounting_manager',
          'inventory_and_costing',
          'warehouse_manager',
          'support'
        ]
      }
    },
    {
      path: 'employee-performance',
      name: 'WarehouseEmployeePerformance',
      component: () => import('@/views/warehouseWorkTracker/pages/EmployeePerformance.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'accounting_manager',
          'inventory_and_costing',
          'warehouse_manager',
          'support'
        ]
      }
    },
    {
      path: 'employee',
      name: 'WarehouseEmployeeList',
      component: () => import('@/views/warehouseWorkTracker/pages/WarehouseEmployee.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'accounting_manager',
          'inventory_and_costing',
          'warehouse_manager',
          'support'
        ]
      }
    },
    {
      path: 'employee-attendance',
      name: 'WarehouseEmployeeAttendance',
      component: () => import('@/views/warehouseWorkTracker/pages/EmployeeAttendance.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'accounting_manager',
          'inventory_and_costing',
          'warehouse_manager',
          'support'
        ]
      }
    },
    {
      path: 'work-type',
      name: 'WarehouseWorkType',
      component: () => import('@/views/warehouseWorkTracker/pages/WarehouseWorkType.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'accounting_manager',
          'inventory_and_costing',
          'warehouse_manager',
          'support'
        ]
      }
    },
    {
      path: 'work-log',
      name: 'WarehouseWorkLog',
      component: () => import('@/views/warehouseWorkTracker/pages/WarehouseWorkLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'accounting_manager',
          'inventory_and_costing',
          'warehouse_manager',
          'support'
        ]
      }
    },
    {
      path: 'employee/print-cards',
      name: 'WarehouseEmployeePrintCards',
      component: () => import('@/views/warehouseWorkTracker/pages/WarehouseEmployeePrintCard.vue'),
      meta: {
        layout: 'Blank',
        middleware: [
          'auth',
          'developer',
          'management',
          'accounting_manager',
          'inventory_and_costing',
          'warehouse_manager',
          'support'
        ]
      }
    }
  ]
}
